import { Divider } from "@mui/material";
import type { ChangeEvent } from "react";
import { useIntl } from "react-intl";

import { Avatar } from "@/components/Avatar/Avatar";
import { Checkbox } from "@/components/Checkbox/Checkbox";
import type { Airline } from "@/features/flights/types/types";

type Props = {
  airlines: Airline[];
  selectedAirlines: string[];
  userManuallySelectedAllAirlines: boolean;
  onSingleAirlineChange: (
    event: ChangeEvent<HTMLInputElement>,
    checked: boolean,
    airline: Airline,
  ) => void;
};

export const AirlinesFilter = ({
  airlines,
  selectedAirlines,
  userManuallySelectedAllAirlines,
  onSingleAirlineChange,
}: Props) => {
  const intl = useIntl();

  const areAllAirlinesSelected = selectedAirlines?.length === airlines.length;

  return (
    <ul>
      {airlines.map((airline) => (
        <li key={airline.name}>
          <label className="my-2 flex justify-between">
            <span className="flex items-center">
              <Avatar
                alt={intl.formatMessage(
                  {
                    id: "flights.airlineLogoAlt",
                    defaultMessage: "{airline} logo",
                  },
                  { airline: airline.name },
                )}
                size="large"
                src={airline.logoUrl}
                fallback={airline.name?.charAt(0) || ""}
              />
              <span className="mr-2 ml-2 font-normal">{airline.name}</span>
            </span>

            <Checkbox
              checked={
                selectedAirlines?.includes(airline.code) &&
                (airlines.length === 1 ||
                  userManuallySelectedAllAirlines ||
                  !areAllAirlinesSelected)
              }
              onChange={(e) =>
                onSingleAirlineChange(e, e.target.checked, airline)
              }
              density="compact"
            />
          </label>
          <Divider />
        </li>
      ))}
    </ul>
  );
};
